import footer from "./../assets/images/footer.svg";

const Footer = () => {
    return (
        <footer className="footer"><img className="footer__image" src={footer} /></footer>
    )
}

export default Footer